<template>
  <footer class="footer">
    <div class="container">
      <p class="footer__contact text-with-icon">
        <i class="material-icons">email</i> <a href="mailto:contact@mcintirefruit.com">contact@mcintirefruit.com</a>
      </p>
      <p class="footer__contact text-with-icon">
        <i class="material-icons">phone</i> 0141 123 4567
      </p>
      <p class="footer__contact text-with-icon">
        <i class="material-icons">schedule</i> Open Monday - Saturday 9am - 5pm
      </p>
      <div class="footer__address">
        <label>Head Office (UK)</label>
        <p>McIntire Fruit</p>
        <p>Fruits Lane</p>
        <p>Scotland</p>
        <p>MC1 1RE</p>
      </div>
      <div class="footer__address">
        <label>Head Office (US)</label>
        <p>McIntire Fruit</p>
        <p>Fruits Lane</p>
        <p>Delaware</p>
        <p>MC1 1RE</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>